import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Twitter24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      d="M20.376 5.287c-.72.43-1.488.764-2.352.908C17.352 5.478 16.392 5 15.336 5 13.32 5 11.64 6.672 11.64 8.774c0 .286.048.573.096.86-3.072-.143-5.76-1.672-7.584-3.917-.336.573-.48 1.194-.48 1.91 0 1.29.672 2.437 1.632 3.153-.624 0-1.152-.19-1.68-.477v.047c0 1.816 1.248 3.344 2.976 3.679a3.117 3.117 0 01-.96.143c-.24 0-.48 0-.672-.048.48 1.481 1.824 2.58 3.456 2.628a7.269 7.269 0 01-4.56 1.624c-.288 0-.576 0-.864-.048A10.372 10.372 0 008.664 20c6.768 0 10.512-5.732 10.512-10.7v-.478A7.12 7.12 0 0021 6.863c-.672.287-1.392.526-2.112.573.624-.573 1.2-1.29 1.488-2.15"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

export default Twitter24;
